import { render, staticRenderFns } from "./ConfirmarDatosTransferenciaCVUCBU.vue?vue&type=template&id=fe762b88&"
import script from "./ConfirmarDatosTransferenciaCVUCBU.vue?vue&type=script&lang=js&"
export * from "./ConfirmarDatosTransferenciaCVUCBU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports